<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card
		card-border
		no-shadow
		class="overflow-hidden report-content"
		:class="{'selected-report': active}"
		@click="handleClick"
	>
		<div slot="no-body">
			<div
				class="pt-2"
				:class="{
					'flex justify-between flex-row-reverse items-center': iconRight,
					'text-center': !iconRight && hideChart,
					'pb-0': !hideChart,
				}"
			>
				<!-- iconos -->
				<vx-tooltip
					class="cursor-pointer"
					style="z-index: 99999"
					:title="$t('Reports.' + typeReport)"
					color="primary"
					position="top"
					:text="description"
				>
					<navigation-icon
						v-if="typeReport === 'location'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></navigation-icon>
					<map-icon
						v-else-if="typeReport === 'historicalposition'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></map-icon>
					<log-in-icon
						v-else-if="typeReport === 'loginout'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></log-in-icon>
					<rss-icon
						v-else-if="typeReport === 'transmission'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></rss-icon>
					<git-pull-request-icon
						v-else-if="typeReport === 'scheduledroute'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></git-pull-request-icon>
					<div v-else-if="typeReport === 'scheduledroutevsexecuted'">
						<git-pull-request-icon
							size="4x"
							class="inline-flex rounded-full icon-shape"
							:class="[`text-${color}`, {'mb-0': !iconRight}]"
						></git-pull-request-icon>
						<git-commit-icon
							size="4x"
							class="inline-flex rounded-full icon-shape"
							:class="[`text-${color}`, {'mb-0': !iconRight}]"
						></git-commit-icon>
					</div>
					<map-pin-icon
						v-else-if="typeReport === 'visitpoint'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></map-pin-icon>
					<user-icon
						v-else-if="typeReport === 'resource'"
						size="4x"
						class="inline-flex rounded-full icon-shape"
						:class="[`text-${color}`, {'mb-0': !iconRight}]"
					></user-icon>
				</vx-tooltip>
				<div class="truncate">
					<h4 class="report-title">{{ $t("Reports." + typeReport) }}</h4>
					<p v-if="typeReport === 'visitpoint'" class="report-subtitle">
						{{ $t("Reports.MultipleVisitPoints") }}
					</p>
					<p v-else class="report-subtitle">{{ statisticTitle }}</p>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import _color from "@/assets/utils/color.js";

import {
	ArchiveIcon,
	MapIcon,
	MapPinIcon,
	LogInIcon,
	NavigationIcon,
	RssIcon,
	GitPullRequestIcon,
	GitCommitIcon,
	UserIcon,
} from "vue-feather-icons";

export default {
	props: {
		active: {
			type: Boolean,
		},
		typeReport: {
			type: String,
			required: true,
		},
		icon: {
			type: String,
			required: true,
		},
		statistic: {
			type: [Number, String],
			required: true,
		},
		statisticTitle: {
			type: String,
		},
		description: {
			type: String,
		},
		chartData: {
			// type: Array,
			// required: true
		},
		color: {
			type: String,
			default: "primary",
		},
		colorTo: {
			type: String,
		},
		type: {
			type: String,
			default: "line",
		},
		iconRight: {
			type: Boolean,
			default: false,
		},
		hideChart: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			chartOptions: null,
		};
	},
	watch: {
		themePrimaryColor() {
			if (this.$refs.apexChart)
				this.$refs.apexChart.updateOptions({theme: {monochrome: {color: this.getHex(this.color)}}});
		},
	},
	computed: {
		themePrimaryColor() {
			return this.$store.state.themePrimaryColor;
		},
	},
	methods: {
		getHex(color) {
			if (_color.isColor(color)) {
				let rgb = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`);
				rgb = rgb.split(",");
				return `#${((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2]))
					.toString(16)
					.slice(1)}`;
			}
			return color;
		},
		gradientToColor(color) {
			const gradientToColors = {
				primary: "#A9A2F6",
				success: "#55DD92",
				warning: "#ffc085",
				danger: "#F97794",
			};

			return gradientToColors[color] ? gradientToColors[color] : gradientToColors["primary"];
		},
		handleClick() {
			this.$emit("handleClickEmit", this.typeReport);
		},
	},
	components: {
		ArchiveIcon,
		MapIcon,
		MapPinIcon,
		LogInIcon,
		NavigationIcon,
		RssIcon,
		GitPullRequestIcon,
		GitCommitIcon,
		UserIcon,
	},
};
</script>
<style lang="scss" scope>
.report-content {
	width: 180px;
	height: 120px;
}

.report-content:hover {
	background: #71729748;
	cursor: pointer;
}

.selected-report {
	background: #71729748;
}

.report-title {
	font-style: normal;
	font-weight: bold;
	font-size: 10px;
	line-height: 12px;
	text-align: center;
	color: #f9841e;
}

.report-subtitle {
	font-style: normal;
	font-weight: 500;
	font-size: 9px;
	line-height: 11px;
	text-align: center;
	color: #8d8d8d;
}

.icon-shape {
	padding: 12px;
	background-color: rgba(244, 113, 12, 0.2);
	stroke: #f9841e;
}
</style>
